import store from '../store'

export function setObjToLocalStorage (key, obj) {
    localStorage.setItem(key, JSON.stringify(obj))
}

export function getObjFromLocalStorage (key) {
    const item = localStorage.getItem(key)
    if (item) {
        return JSON.parse(item)
    }
    return null
}

export function setTableFiltersToLocalStorage (tableName, filters) {
    const userId = store.getters['authModule/getUserId']
    setObjToLocalStorage(`${tableName}-filters-${userId}`, filters)
}

export function getTableFiltersFromLocalStorage (tableName) {
    const userId = store.getters['authModule/getUserId']
    return getObjFromLocalStorage(`${tableName}-filters-${userId}`)
}
